import { useState } from 'react'
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents
} from 'react-leaflet'
import { decryptLocation } from '../lib/cryptic'

import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

export const DecryptLocationPage = () => {
  const [decrypted, setDecrypted] = useState(null)
  const [position, setPosition] = useState(null)

  const customIcon = new Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/484/484167.png",
    iconSize: [32, 32]
  })

  function LocationMarker() {
    const map = useMapEvents({
      click(event) {
        setPosition(event.latlng)
        map.flyTo(event.latlng, 14)
      },
    })

    if (position) {
      map.flyTo(position, 14)
    }

    return position === null ? null : (
      <Marker position={position} icon={customIcon}>
        <Popup>Decrypted location</Popup>
      </Marker>
    )
  }

  const decryptForm = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const latitude = formData.get('latitude');
    const longitude = formData.get('longitude');
    const decryptedData = decryptLocation(latitude, longitude);

    setPosition({ lat: decryptedData.lat, lng: decryptedData.long });
    setDecrypted(decryptedData);
  };
 
  return (
    <div className="decrypt-location-page">
      <h3 className="page-title">Decrypt Location</h3>

      <form className="decrypt-form" onSubmit={decryptForm}>
        <input type="text" name="latitude" placeholder="Latitude" />
        <input type="text" name="longitude" placeholder="Longitude" />

        <button type="submit">Decrypt</button>
      </form>

      <MapContainer
        center={[52.687201, 13.469969]}
        zoom={5}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
        />

        <LocationMarker />
      </MapContainer>

      {decrypted && (
        <div className="result">
          <h6>Decrypted Location:</h6>
          <p>{decrypted.lat} {decrypted.long}</p>
        </div>
      )}
    </div>
  );
}